import { useState, useEffect, useCallback } from 'react';

export default function useKeypress(xKey, isEnabled = true) {
    const [keyPressed, setKeyPressed] = useState(false);

    const handleKeyDown = ({ key }) => {
        if (key === xKey && key !== keyPressed) {
            setKeyPressed(key);
        }
    };

    const handleKeyUp = ({ key }) => {
        if (key === xKey) {
            setKeyPressed(null);
        }
    };

    useEffect(() => {
		if (isEnabled) {
			document.addEventListener('keydown', handleKeyDown, true);
			document.addEventListener('keyup', handleKeyUp, true);	
		}

        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
            document.removeEventListener('keyup', handleKeyUp, true);
        };
    }, []);

    return keyPressed;
}